import moment from 'moment';
import _ from 'lodash';

const getCreateClassifierButtonProps = (newClassifierName, isInvalidQuery) => {
  return newClassifierName === '' || isInvalidQuery
        ? {disabled: true}
        : {};
}

const getRandomString = (length) => {
  var result = '';
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
}

const getUniqueId = () => {
  return moment.utc().format('YMMDDHHmmssSSS') + getRandomString(3);
}

const createNewRule = () => {
  return {name: getUniqueId(), type: 'rule', shoulDelete: true};
}

const createNewGroup = (shoulDelete) => {
  return {name: getUniqueId(), type: 'group', connector: 'AND', shoulDelete: shoulDelete, children: [createNewRule()]};
}

const deleteObjectFromTree = (elemName, tree) => {
  var i = tree.length;
  while (i--) {
    if (tree[i]['name'] === elemName && !!tree[i]['shoulDelete']) {
      tree.splice(i,1);
    }
    else if (!!tree[i]['children']) {
      deleteObjectFromTree(elemName, tree[i]['children']);
    }
  }
  return tree;
}

const getObjectFromTree = (elemName, tree) => {
  for (var iterator = 0; iterator< tree.length ; iterator++) {
    if (tree[iterator].name === elemName) { return tree[iterator]; }
    else if(!!tree[iterator].children) {
      const childSearch = getObjectFromTree(elemName, tree[iterator].children);
      if (!!childSearch) return childSearch;
    }
  }
}

const getTreeObjectByName = (elemName, queryTreeState) => {
  return getObjectFromTree(elemName, queryTreeState);
}

const getTreeObjectBySynthEvent = (synthEvent, queryTreeState) => {
  const elemName = synthEvent.currentTarget.closest('.EntityShowCase').getAttribute('name');
  return getTreeObjectByName(elemName, queryTreeState);
}

const getTermFromTree = (queryTree) => {
  var queryTerm = '';
  for (var aux = 0 ; aux < queryTree.length ; aux++) {
    var isLastTerm = aux === queryTree.length - 1;
    if (queryTree[aux].type === 'group') {
      var childTerms = `${queryTree[aux].connector}: [${getTermFromTree (queryTree[aux].children)}]`,
          childTerms = _.trimRight(childTerms, ',');
          queryTerm += childTerms.length < 11 ? '' : ` {${childTerms}} ${!isLastTerm ? ',' : ''}`;

    } else if (!!queryTree[aux].value && queryTree[aux].value !== '') {
      queryTerm += ` ${queryTree[aux].value}${!isLastTerm ? ',' : ''}`;
    }

    if (isLastTerm && !_.isEmpty(queryTerm) && queryTerm.substr(queryTerm.length-1,queryTerm.length) === ',') queryTerm = _.trimRight(queryTerm, ',');

  }
  return queryTerm;
}

module.exports = {
  getRandomString,
  getUniqueId,
  createNewRule,
  createNewGroup,
  deleteObjectFromTree,
  getTermFromTree,
  getObjectFromTree,
  getTreeObjectByName,
  getTreeObjectBySynthEvent,
  getCreateClassifierButtonProps
}



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.helper.jsx